import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Button from '@mui/material/Button';
import { connect } from 'react-redux'

import DateTimePreview from './date-time-preview'
import SettingsPreview from './settings-preview'
import DateTimeModal from './date-time-modal'
import ConnectedSettingsSelectorPanel from './connected-settings-selector-panel'

import { setMainPanelContent } from '../../actions/ui'
import i18n from "../../../i18nSetup";
import Grid from '@mui/material/Grid';
import {routingQuery} from "../../actions/api";
import Popover from "@mui/material/Popover";

class TabbedFormPanel extends Component {
  static propTypes = {
    icons: PropTypes.object
  };

  _onHideClick = () => {
    this.props.setMainPanelContent(null)
    this.props.routingQuery()
  };

  _onEditDateTimeClick = (event) => {
    const {mainPanelContent, setMainPanelContent} = this.props;
    setMainPanelContent(mainPanelContent === 'EDIT_DATETIME' ? null : 'EDIT_DATETIME');
    this.setState({anchorEl: event.currentTarget})
  }

  _onCloseClick = (event) => {
    const {mainPanelContent, setMainPanelContent} = this.props;
    setMainPanelContent(mainPanelContent === 'EDIT_DATETIME' ? null : 'EDIT_DATETIME');
    this._onHideClick();
  };

  _onEditSettingsClick = () => {
    const {mainPanelContent, setMainPanelContent} = this.props;
    let currentMainPanelContent = mainPanelContent;
    setMainPanelContent(mainPanelContent === 'EDIT_SETTINGS' ? null : 'EDIT_SETTINGS');

    if (currentMainPanelContent === 'EDIT_SETTINGS') {
      this._onHideClick();
    }
  };


  constructor (props) {
    super(props)
    this.state = {
      anchorEl: null
    }
  }

  render () {
    const { icons, mainPanelContent } = this.props;
    const id = mainPanelContent === 'EDIT_DATETIME' ? 'dt-popover' : undefined;

    return (
      <>
        <Grid spacing={2} container justifyContent="space-between" direction="row" alignItems="center">
          <Grid item >
           <DateTimePreview
              onClick={this._onEditDateTimeClick}
              isPopoverOpened={mainPanelContent === 'EDIT_DATETIME'}
            />
          </Grid>
          <Grid item >
            <SettingsPreview onClick={this._onEditSettingsClick} isOpen={mainPanelContent === 'EDIT_SETTINGS'}/>
          </Grid>
        </Grid>
        {
          <Popover
            id={id}
            open={mainPanelContent === 'EDIT_DATETIME'}
            anchorEl={this.state.anchorEl}
            onClose={this._onCloseClick}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
          >
            <DateTimeModal/>
          </Popover>
        }
        {mainPanelContent === 'EDIT_SETTINGS' && (<ConnectedSettingsSelectorPanel icons={icons}/>)}
      </>
    )
  }
}

// connect to redux store

const mapStateToProps = (state, ownProps) => {
  return {
    mainPanelContent: state.otp.ui.mainPanelContent,

  }
}

const mapDispatchToProps = {
  setMainPanelContent,
  routingQuery
}

export default connect(mapStateToProps, mapDispatchToProps)(TabbedFormPanel)
